










import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { Protocol } from '@/components'
const commonModules = namespace('commonModules')
const quotaApplication = namespace('quotaApplication')
import { getStore } from '@/utils/utils'
@Component({
  name: 'personMessageBack',
  components: {
    Protocol,
  },
})
export default class personMessage extends Vue {
  @quotaApplication.Action queryApplicationProtol: any
  @quotaApplication.State protolHtml: any
  @quotaApplication.State loadingPage
  htmlData: string = ''
  @Watch('protolHtml', { immediate: true })
  onChanged(val: any) {
    this.htmlData = val && val['compactContent']
    // this.htmlData = val && val[0] && val[0]['compContent']
  }
  created() {
    let custName = getStore('userInfo') ? JSON.parse(getStore('userInfo')).custName : ''
    let certId = getStore('userInfo') ? JSON.parse(getStore('userInfo')).certId : ''
    this.queryApplicationProtol({ compactType: '52', certId: certId, userName: custName })
  }
}
